import type { Component } from 'vue'

export type AccountSettingsTabVariant = 'web' | 'mobile'

export interface AccountSettingsTabComponents {
  web: Component
  mobile: Component
}

/**
 * Tab organisms owned by layers that only some apps compose (e.g. the ClientPortal-only Events
 * tab). The owning layer registers them from its own Nuxt plugin, so common-layer never imports
 * them and apps that skip the layer never resolve its module graph at build time.
 *
 * Module-level on purpose: entries are static component definitions registered identically on
 * every app init, so sharing them across SSR requests carries no request or tenant state.
 */
const registeredTabComponents = new Map<string, AccountSettingsTabComponents>()

export function registerAccountSettingsTabComponent(componentName: string, components: AccountSettingsTabComponents): void {
  registeredTabComponents.set(componentName, components)
}

export function resolveRegisteredAccountSettingsTabComponent(
  componentName: string,
  variant: AccountSettingsTabVariant
): Component | undefined {
  return registeredTabComponents.get(componentName)?.[variant]
}

export function clearRegisteredAccountSettingsTabComponents(): void {
  registeredTabComponents.clear()
}
